import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

interface CommentComposerProps {
  initialValue?: string
  onSubmit: (body: string) => void
  onCancel?: () => void
}

/** Markdown, `Cmd/Ctrl+Enter` envía (CLAUDE.md §6). */
export function CommentComposer({ initialValue = '', onSubmit, onCancel }: CommentComposerProps) {
  const { t } = useTranslation()
  const [value, setValue] = useState(initialValue)
  const textareaRef = useRef<HTMLTextAreaElement>(null)
  const isEditing = initialValue.length > 0

  useEffect(() => {
    if (isEditing) textareaRef.current?.focus()
  }, [isEditing])

  function submit(): void {
    const trimmed = value.trim()
    if (!trimmed) return
    onSubmit(trimmed)
    setValue('')
  }

  return (
    <div className="flex flex-col gap-2">
      <textarea
        ref={textareaRef}
        value={value}
        onChange={(event) => setValue(event.target.value)}
        onKeyDown={(event) => {
          if ((event.metaKey || event.ctrlKey) && event.key === 'Enter') {
            event.preventDefault()
            submit()
          }
          if (event.key === 'Escape' && onCancel) onCancel()
        }}
        rows={3}
        placeholder={t('task.detail.commentPlaceholder')}
        className="resize-y rounded-card bg-surface-hi px-3 py-2 text-body text-text outline-none focus-visible:ring-2 focus-visible:ring-accent"
      />
      <div className="flex justify-end gap-2">
        {onCancel && (
          <button
            type="button"
            onClick={onCancel}
            className="rounded-card px-3 py-1 text-meta text-text hover:bg-surface-hi focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent"
          >
            {t('common.cancel')}
          </button>
        )}
        <button
          type="button"
          onClick={submit}
          className="rounded-card border border-border px-3 py-1 text-meta text-text hover:bg-surface-hi focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent"
        >
          {t('task.detail.commentSubmit')}
        </button>
      </div>
    </div>
  )
}
